var _g, _path, _path2, _path3, _path4, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidirectonalConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      left: 1,
      top: 1,
      width: 32,
      height: 30,
      display: "block",
      position: "relative",
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)",
    style: {
      visibility: "visible"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.18 23.16 L 23.98 6.36",
    fill: "none",
    stroke: "white",
    strokeWidth: 9.3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    visibility: "hidden"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.18 23.16 L 23.98 6.36",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.65 24.69 L 6.67 21.64 L 7.18 23.16 L 8.7 23.67 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.51 4.83 L 24.49 7.88 L 23.98 6.36 L 22.46 5.85 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidirectonalConnector);
export default __webpack_public_path__ + "static/media/bidirectonal-connector.e85690bb689b55f388f282ac6bd31126.svg";
export { ForwardRef as ReactComponent };